import { useState, useEffect } from 'react';

/**
 * Hook para obtener la geolocalización del usuario
 * @returns {Object} { location, error, loading }
 */
export const useGeolocation = () => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si el navegador soporta geolocalización
    if (!navigator.geolocation) {
      setError('Tu navegador no soporta geolocalización');
      setLoading(false);
      return;
    }

    // Obtener ubicación
    const successHandler = (position) => {
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      });
      setLoading(false);
      console.log('📍 Ubicación obtenida:', position.coords.latitude, position.coords.longitude);
    };

    const errorHandler = (err) => {
      console.warn('⚠️ Error obteniendo ubicación:', err.message);
      setError(err.message);
      setLoading(false);
      // No es un error crítico, solo no tendremos ubicación precisa
    };

    // Opciones de geolocalización
    const options = {
      enableHighAccuracy: false, // No necesitamos GPS preciso
      timeout: 5000, // 5 segundos máximo
      maximumAge: 5 * 60 * 1000 // Cache de 5 minutos
    };

    navigator.geolocation.getCurrentPosition(
      successHandler,
      errorHandler,
      options
    );
  }, []);

  return { location, error, loading };
};
